var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 720.5,
    cy: 261.5,
    r: 62.5,
    fill: "#17C7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 499.645C288.925 445.572 277.138 368.748 222.4 328.055C167.662 287.363 90.6996 298.21 50.5011 352.283C10.3026 406.356 22.0899 483.181 76.8276 523.873C131.565 564.565 208.528 553.719 248.727 499.645Z",
    fill: "url(#loaderGradient36)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.264,
    cy: 490.095,
    rx: 163.5,
    ry: 166.5,
    transform: "rotate(-2.37658 616.264 490.095)",
    fill: "#ED801B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient36",
    x1: 149.086,
    y1: 467.099,
    x2: 153.439,
    y2: 302.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36);
export default __webpack_public_path__ + "static/media/36.9d0ec600.svg";
export { ForwardRef as ReactComponent };